import React from 'react';
import { Section } from '../../../../api/appConfiguration/types';
import { Components } from './styled';
import AdditionalActions from '../../../../components/ProjectTable/cells/AdditionalActions';
import Options from '../Options';
import { getDisplayNames } from '../../../../api/utils';

const SectionCard = ({
  section,
  onEdit,
  onMoveUp,
  onMoveDown,
  onDelete,
}: {
  section: Section;
  onEdit: (itemKey: string, section: Section) => void;
  onMoveUp: (itemKey: string) => void;
  onMoveDown: (itemKey: string) => void;
  onDelete: (itemKey: string) => void;
}) => {
  const cellType = section?.style?.cellType;
  const maxVisibleItems = section?.sectionVisibleItems;

  return (
    <Components.Container>
      <Components.Header>
        <Components.Key>ID: {section.key}</Components.Key>
        <Options
          itemKey={section.key}
          section={section}
          onEdit={onEdit}
          onMoveUp={onMoveUp}
          onMoveDown={onMoveDown}
          onDelete={onDelete}
        />
      </Components.Header>
      <Components.Title>{section?.title ? section.title : getDisplayNames.sectionType(section.type)}</Components.Title>
      {section?.title !== undefined && (
        <Components.Field>Type: {getDisplayNames.sectionType(section.type)}</Components.Field>
      )}
      {cellType && <Components.Field>Style: {getDisplayNames.cellType(cellType)}</Components.Field>}
      {maxVisibleItems && <Components.Field>Visible Items: {maxVisibleItems}</Components.Field>}
    </Components.Container>
  );
};

export default SectionCard;
